(()=>{
if(window.MOGA_CLOUD)return;

const cfg=window.MOGA_CLOUD_CONFIG||{};
const API=String(cfg.apiBase||'').replace(/\/+$/,'');
const SESSION_KEY='moga_cloud_session_v1';
const DEVICE_KEY='moga_cloud_device_id_v1';
const RELOAD_GUARD='moga_cloud_reload_guard_v1';
const TENANT_KEY='moga_cloud_tenant_id_v1';
const APP_VERSION='3.1-cloud-tenant-safe';
const NEVER_SYNC=new Set([
  'moga_invoice_pro_session_v1',
  'moga_cloud_session_v1',
  'moga_cloud_device_id_v1',
  'moga_cloud_reload_guard_v1',
  'moga_cloud_tenant_id_v1',
  'moga_emergency_snapshot_v2',
  'moga_emergency_snapshot_time_v2',
  'moga_pre_restore_guard_v2',
  'moga_tracking_guard_v1',
  'moga_last_full_backup',
  'moga_payment_toast_seen'
]);
const TRACK_PREFIX='moga_';

let token='';
let tenant=null;
let device=null;
let ready=false;
let suppress=false;
let versions={};
let dirty=new Map();
let inFlight=new Set();
let conflicts=new Map();
let flushTimer=null;
let pollTimer=null;
let islandTimer=null;
let lastStatusKind='';
let tenantWasSwitched=false;

const nativeSet=Storage.prototype.setItem;
const nativeRemove=Storage.prototype.removeItem;
const nativeGet=Storage.prototype.getItem;

function isTracked(key){
  key=String(key||'');
  return key.startsWith(TRACK_PREFIX)&&!NEVER_SYNC.has(key)&&!key.startsWith('moga_cloud_');
}
function id(){
  let v=nativeGet.call(localStorage,DEVICE_KEY);
  if(!v){v=crypto.randomUUID();nativeSet.call(localStorage,DEVICE_KEY,v)}
  return v;
}
function showBoot(text='JUNGIAMASI PRIE MOGA CLOUD…'){
  let el=document.getElementById('mogaCloudBoot');
  if(!el){
    el=document.createElement('div');el.id='mogaCloudBoot';
    el.innerHTML='<div class="moga-cloud-boot-card"><div class="moga-cloud-spinner"></div><b></b><small>PC ir Android naudos tą pačią MOGA SF paskyrą.</small></div>';
    const s=document.createElement('style');s.id='mogaCloudStyles';s.textContent=`
#mogaCloudBoot{position:fixed;inset:0;z-index:2147483646;display:grid;place-items:center;background:rgba(7,7,7,.96);color:#fff;font-family:Arial,sans-serif}.moga-cloud-boot-card{width:min(420px,calc(100vw - 32px));padding:28px;border:1px solid #343434;border-radius:22px;background:#111;text-align:center;box-shadow:0 28px 90px #000}.moga-cloud-boot-card b{display:block;margin:14px 0 7px;font-size:14px;letter-spacing:.5px}.moga-cloud-boot-card small{color:#888;font-size:10px}.moga-cloud-spinner{width:38px;height:38px;margin:auto;border-radius:50%;border:3px solid #333;border-top-color:#ff8a00;border-right-color:#ff5f9e;animation:mogaCloudSpin .8s linear infinite}@keyframes mogaCloudSpin{to{transform:rotate(360deg)}}
#mogaCloudStatus{display:inline-flex;align-items:center;gap:6px;margin-left:8px;padding:5px 9px;border:1px solid #3a3a3a;border-radius:999px;background:#141414;color:#aaa;font:800 9px/1 Arial,sans-serif;white-space:nowrap}#mogaCloudStatus:before{content:'';width:7px;height:7px;border-radius:50%;background:#999}#mogaCloudStatus.ok{color:#83e5a6;border-color:#265739}#mogaCloudStatus.ok:before{background:#43d176}#mogaCloudStatus.sync{color:#ffd17b;border-color:#63491c}#mogaCloudStatus.sync:before{background:#f5a623}#mogaCloudStatus.err{color:#ff9da2;border-color:#652c31}#mogaCloudStatus.err:before{background:#ff5b62}
#mogaCloudIsland{position:fixed;right:24px;bottom:24px;z-index:2147483644;display:flex;align-items:center;max-width:44px;height:44px;overflow:hidden;border:1px solid #3c3c3c;border-radius:999px;background:rgba(16,16,16,.94);color:#ddd;box-shadow:0 12px 34px #0006;backdrop-filter:blur(12px);opacity:0;transform:translateY(10px) scale(.94);pointer-events:none;transition:max-width .28s ease,opacity .18s ease,transform .18s ease,border-color .18s ease}#mogaCloudIsland.show{opacity:1;transform:translateY(0) scale(1)}#mogaCloudIsland.expand{max-width:310px}#mogaCloudIsland .dot{width:32px;height:32px;min-width:32px;margin-left:5px;border-radius:50%;display:grid;place-items:center;background:linear-gradient(135deg,#ff8a00,#ff5f9e);color:#111;font:900 15px/1 Arial,sans-serif;box-shadow:0 0 18px #ff7d5c38}#mogaCloudIsland .txt{padding:0 14px 0 9px;white-space:nowrap;font:800 10px/1 Arial,sans-serif;letter-spacing:.15px}#mogaCloudIsland.sync{border-color:#65491f}#mogaCloudIsland.ok{border-color:#285b3d}#mogaCloudIsland.err{border-color:#6b3035}#mogaCloudIsland.sync .dot{animation:mogaCloudPulse 1s ease-in-out infinite alternate}#mogaCloudIsland.ok .dot{background:#43d176}#mogaCloudIsland.err .dot{background:#ff5b62;color:#fff}@keyframes mogaCloudPulse{from{transform:scale(.92)}to{transform:scale(1.05)}}@media(max-width:700px){#mogaCloudIsland{right:14px;bottom:86px}}
#mogaCloudConflict{position:fixed;left:50%;bottom:18px;transform:translateX(-50%);z-index:2147483645;display:none;width:min(720px,calc(100vw - 24px));padding:14px 15px;border:1px solid #6d4620;border-radius:14px;background:#1b1209;color:#ffe0a5;box-shadow:0 18px 70px #0009;font:12px/1.45 Arial,sans-serif}#mogaCloudConflict.open{display:block}#mogaCloudConflict b{color:#fff}#mogaCloudConflict button{margin-left:8px;border:1px solid #83571f;border-radius:999px;padding:7px 10px;background:#2b1c0c;color:#fff;font-weight:800;cursor:pointer}
`;
    document.head.appendChild(s);document.documentElement.appendChild(el);
  }
  el.querySelector('b').textContent=text;
}
function hideBoot(){document.getElementById('mogaCloudBoot')?.remove()}
function showIsland(kind,text){
  if(!document.body)return;
  let el=document.getElementById('mogaCloudIsland');
  if(!el){
    el=document.createElement('div');el.id='mogaCloudIsland';
    el.innerHTML='<span class="dot">↻</span><span class="txt"></span>';
    document.body.appendChild(el);
  }
  clearTimeout(islandTimer);
  el.className=`${kind||''} show`;
  el.querySelector('.dot').textContent=kind==='ok'?'✓':kind==='err'?'!':'↻';
  el.querySelector('.txt').textContent=text||'Sinchronizuojami duomenys…';
  requestAnimationFrame(()=>el.classList.add('expand'));
  const delay=kind==='sync'?0:(kind==='err'?4200:1600);
  if(delay){
    islandTimer=setTimeout(()=>{
      el.classList.remove('expand');
      setTimeout(()=>el.classList.remove('show'),260);
    },delay);
  }
}
function status(kind,text){
  let el=document.getElementById('mogaCloudStatus');
  if(!el&&document.body){
    el=document.createElement('span');el.id='mogaCloudStatus';
    const target=document.querySelector('.toolbar-status')||document.querySelector('.toolbar');
    if(target)target.appendChild(el);else document.body.appendChild(el);
  }
  if(el){el.className=kind||'';el.textContent=text||''}
  if(kind==='sync')showIsland('sync',text==='NAUJI CLOUD DUOMENYS'?'Gaunami nauji Cloud duomenys…':'Sinchronizuojami duomenys…');
  else if(kind==='err')showIsland('err',text||'Cloud klaida');
  else if(kind==='ok'&&lastStatusKind==='sync')showIsland('ok','Cloud atnaujinta ✓');
  lastStatusKind=kind||'';
}
function conflictBar(){
  let el=document.getElementById('mogaCloudConflict');
  if(!el){el=document.createElement('div');el.id='mogaCloudConflict';document.body.appendChild(el)}
  if(!conflicts.size){el.classList.remove('open');el.innerHTML='';return}
  el.innerHTML=`<b>MOGA CLOUD KONFLIKTAS</b> · ${conflicts.size} duomenų blokas(-ai) pakeisti kitame įrenginyje. Vietinė versija neperrašyta.<button data-cloud-reload>ATKURTI CLOUD VERSIJĄ</button><button data-cloud-force>IŠSAUGOTI ŠIO ĮRENGINIO VERSIJĄ</button>`;
  el.classList.add('open');
  el.querySelector('[data-cloud-reload]').onclick=()=>resolveAll('cloud');
  el.querySelector('[data-cloud-force]').onclick=()=>resolveAll('local');
}
async function req(path,opt={}){
  const headers=new Headers(opt.headers||{});headers.set('Accept','application/json');if(token)headers.set('Authorization','Bearer '+token);
  const r=await fetch(API+path,{...opt,headers,cache:'no-store'});
  const ct=r.headers.get('content-type')||'';
  const data=ct.includes('application/json')?await r.json().catch(()=>({})):null;
  if(!r.ok){const e=new Error(data?.message||`MOGA Cloud HTTP ${r.status}`);e.status=r.status;e.data=data;throw e}
  return data;
}
async function getLicense(){
  if(window.MOGA_LICENSE_SESSION?.code)return window.MOGA_LICENSE_SESSION;

  if(window.MOGA_LICENSE_READY){
    const readyResult=await window.MOGA_LICENSE_READY;
    if(readyResult?.code)return readyResult;
    if(window.MOGA_LICENSE_SESSION?.code)return window.MOGA_LICENSE_SESSION;
  }

  for(const storage of [localStorage,sessionStorage]){
    try{
      const raw=storage.getItem('moga_invoice_pro_session_v1');
      if(!raw)continue;
      const data=JSON.parse(raw);
      if(data?.code)return data;
    }catch(_){}
  }

  return await new Promise((resolve,reject)=>{
    const timer=setTimeout(()=>reject(new Error('Licencijos sesija neparuošta.')),15000);
    window.addEventListener('moga:license-ready',e=>{
      clearTimeout(timer);
      const lic=e.detail||window.MOGA_LICENSE_SESSION;
      if(lic?.code)resolve(lic);
      else reject(new Error('Licencijos kodas nerastas.'));
    },{once:true});
  });
}

function normalizeLicenseCode(v){
  return String(v||'').trim().replace(/\s+/g,'').toUpperCase();
}
function clearTrackedLocal(){
  const keys=[];
  for(let i=0;i<localStorage.length;i++){
    const k=localStorage.key(i);
    if(k&&isTracked(k))keys.push(k);
  }
  suppress=true;
  try{for(const k of keys)nativeRemove.call(localStorage,k)}
  finally{suppress=false}
  dirty.clear();inFlight.clear();conflicts.clear();versions={};conflictBar();
}

function readSession(){try{return JSON.parse(nativeGet.call(localStorage,SESSION_KEY)||'null')}catch(_){return null}}
function saveSession(x){nativeSet.call(localStorage,SESSION_KEY,JSON.stringify(x))}
function clearSession(){nativeRemove.call(localStorage,SESSION_KEY)}
async function authenticate(){
  const lic=await getLicense();
  const licCode=normalizeLicenseCode(lic?.code);
  const isTrial=lic?.license?.trial===true||licCode.startsWith('TRIAL-');
  const cached=readSession();

  if(cached?.token){
    const cachedCode=normalizeLicenseCode(cached.licenseCode);
    const mayUseCached=isTrial ? true : (cachedCode && cachedCode===licCode);

    if(mayUseCached){
      token=cached.token;
      try{
        const me=await req('/v1/auth/me');
        tenant=me.tenant;device=me.device;
        saveSession({...cached,token:cached.token,tenant:me.tenant,device:me.device,licenseCode:licCode||cachedCode});
        return;
      }catch(e){
        if(e.status!==401)throw e;
        clearSession();token='';
      }
    }else{
      tenantWasSwitched=true;
      clearSession();token='';
    }
  }

  if(isTrial){
    throw new Error('Bandymo Cloud sesija nerasta arba nebegalioja. Prisijunkite iš naujo.');
  }

  const r=await req('/v1/auth/login',{
    method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({
      code:licCode,deviceId:id(),deviceName:navigator.userAgentData?.platform||navigator.platform||'Web naršyklė',platform:'web',appVersion:APP_VERSION
    })
  });
  token=r.token;tenant=r.tenant;device=r.device;
  saveSession({token:r.token,expiresAt:r.expiresAt,tenant:r.tenant,device:r.device,licenseCode:licCode});
}
function collectLocal(){
  const out={};for(let i=0;i<localStorage.length;i++){const k=localStorage.key(i);if(k&&isTracked(k))out[k]=nativeGet.call(localStorage,k)}return out;
}
async function seedCloud(local){
  const entries=Object.entries(local);if(!entries.length)return;
  for(let i=0;i<entries.length;i+=80){
    const changes=entries.slice(i,i+80).map(([key,value])=>({key,value,baseVersion:0,mutationId:crypto.randomUUID()}));
    const r=await req('/v1/state/batch',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({changes})});
    for(const x of r.results||[])if(x.ok)versions[x.key]=x.version;
  }
}
function applyCloudState(state,serverVersions){
  let changed=false;suppress=true;
  try{
    const local=collectLocal();
    for(const [key,ver] of Object.entries(serverVersions||{})){
      versions[key]=Number(ver||0);
      if(Object.prototype.hasOwnProperty.call(state||{},key)){
        const value=state[key];if(nativeGet.call(localStorage,key)!==value){nativeSet.call(localStorage,key,value);changed=true}
      }else if(Object.prototype.hasOwnProperty.call(local,key)){
        nativeRemove.call(localStorage,key);changed=true;
      }
    }
  }finally{suppress=false}
  return changed;
}
async function bootstrap(){
  const b=await req('/v1/bootstrap');
  versions={...(b.versions||{})};
  const local=collectLocal();

  if(!b.initialized){
    // Keičiant licenciją NIEKADA nekeliame ankstesnio tenant localStorage į naują Cloud paskyrą.
    if(tenantWasSwitched)return false;
    status('sync','KELIAMA Į CLOUD');
    await seedCloud(local);
    return false;
  }

  const changed=applyCloudState(b.state||{},b.versions||{});
  if(!tenantWasSwitched){
    // Trūkstamus vietinius raktus seediname tik tame pačiame tenante.
    const missing=Object.entries(local).filter(([k])=>!Object.prototype.hasOwnProperty.call(b.versions||{},k));
    if(missing.length)await seedCloud(Object.fromEntries(missing));
  }
  return changed;
}
function schedule(key,value,deleted=false){
  if(!ready||suppress||!isTracked(key))return;
  dirty.set(key,{key,value,deleted,mutationId:crypto.randomUUID()});
  status('sync','SINCHRONIZUOJAMA');
  clearTimeout(flushTimer);flushTimer=setTimeout(flush,80);
}
async function flush(){
  if(!ready||!dirty.size)return;
  const candidates=[];
  for(const [key,item] of dirty){if(!inFlight.has(key)&&!conflicts.has(key)){candidates.push(item);if(candidates.length>=50)break}}
  if(!candidates.length)return;
  candidates.forEach(x=>inFlight.add(x.key));
  const payload=candidates.map(x=>({key:x.key,value:x.value,deleted:x.deleted,baseVersion:Number(versions[x.key]||0),mutationId:x.mutationId}));
  try{
    let data;
    try{data=await req('/v1/state/batch',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({changes:payload})})}
    catch(e){if(e.status===409)data=e.data;else throw e}
    for(const r of data?.results||[]){
      const sent=candidates.find(x=>x.key===r.key);if(!sent)continue;
      if(r.ok){versions[r.key]=r.version;if(dirty.get(r.key)?.mutationId===sent.mutationId)dirty.delete(r.key)}
      else if(r.conflict){conflicts.set(r.key,{local:dirty.get(r.key)||sent,serverVersion:r.currentVersion});}
    }
    conflictBar();
    status(conflicts.size?'err':dirty.size?'sync':'ok',conflicts.size?'KONFLIKTAS':dirty.size?'SINCHRONIZUOJAMA':'CLOUD ✓');
  }catch(e){console.error('MOGA Cloud sync klaida',e);status('err','CLOUD KLAIDA');setTimeout(()=>{if(dirty.size)flush()},3000)}
  finally{candidates.forEach(x=>inFlight.delete(x.key));if(dirty.size&&!conflicts.size)setTimeout(flush,30)}
}
async function resolveAll(mode){
  if(mode==='cloud'){
    status('sync','ATKURIAMA CLOUD');
    const b=await req('/v1/bootstrap');
    const changed=applyCloudState(b.state||{},b.versions||{});conflicts.clear();dirty.clear();conflictBar();if(changed)window.dispatchEvent(new CustomEvent('moga:data-ready',{detail:{source:'cloud-conflict-restore'}}));status('ok','CLOUD ✓');return;
  }
  if(mode==='local'){
    for(const [key,c] of conflicts){versions[key]=Number(c.serverVersion||0);const v=nativeGet.call(localStorage,key);dirty.set(key,{key,value:v,deleted:v===null,mutationId:crypto.randomUUID()})}
    conflicts.clear();conflictBar();await flush();
  }
}
async function poll(){
  if(!ready||dirty.size||inFlight.size||conflicts.size)return;
  try{
    // Kas 15 s tikriname tik mažą versijų sąrašą.
    // Pilną bootstrap (prekės, SF, sandėlis ir t. t.) siunčiamės tik tada,
    // kai kitame įrenginyje realiai kažkas pasikeitė.
    const v=await req('/v1/versions');
    const remoteVersions=v.versions||{};
    const remoteChanged=
      Object.entries(remoteVersions).some(([k,ver])=>Number(versions[k]||0)!==Number(ver||0)) ||
      Object.keys(versions).some(k=>!Object.prototype.hasOwnProperty.call(remoteVersions,k));

    if(remoteChanged){
      status('sync','NAUJI CLOUD DUOMENYS');
      const b=await req('/v1/bootstrap');
      const changed=applyCloudState(b.state||{},b.versions||{});
      if(changed){
        window.dispatchEvent(new CustomEvent('moga:data-ready',{detail:{source:'cloud-poll',versions:{...versions}}}));
        window.dispatchEvent(new CustomEvent('moga:cloud-updated',{detail:{versions:{...versions}}}));
      }
    }
    status('ok','CLOUD ✓');
  }catch(e){
    console.warn('MOGA Cloud poll',e);
    status('err','CLOUD OFFLINE');
  }
}

Storage.prototype.setItem=function(key,value){
  nativeSet.call(this,key,value);
  if(this===localStorage)schedule(String(key),String(value),false);
};
Storage.prototype.removeItem=function(key){
  nativeRemove.call(this,key);
  if(this===localStorage)schedule(String(key),null,true);
};

async function start(){
  if(!API){console.warn('MOGA Cloud: API adresas nenustatytas.');hideBoot();return}
  showBoot();
  try{
    await authenticate();

    const currentTenantId=String(tenant?.id||'');
    const previousTenantId=String(nativeGet.call(localStorage,TENANT_KEY)||'');
    if(currentTenantId && previousTenantId && currentTenantId!==previousTenantId){
      tenantWasSwitched=true;
    }
    if(tenantWasSwitched){
      showBoot('KEIČIAMA MOGA SF PASKYRA…');
      clearTrackedLocal();
      nativeRemove.call(sessionStorage,RELOAD_GUARD);
    }
    if(currentTenantId)nativeSet.call(localStorage,TENANT_KEY,currentTenantId);

    showBoot('SINCHRONIZUOJAMI DUOMENYS…');
    const changed=await bootstrap();
    if(changed){
      const guard=Number(nativeGet.call(sessionStorage,RELOAD_GUARD)||0);
      if(!guard||Date.now()-guard>10000){nativeSet.call(sessionStorage,RELOAD_GUARD,String(Date.now()));location.reload();return}
    }
    nativeRemove.call(sessionStorage,RELOAD_GUARD);
    ready=true;window.MOGA_CLOUD_READY_STATE=true;
    hideBoot();status('ok','CLOUD ✓');
    window.dispatchEvent(new CustomEvent('moga:cloud-ready',{detail:{tenant,device,versions:{...versions}}}));
    pollTimer=setInterval(poll,15000);
  }catch(e){
    console.error('MOGA Cloud start klaida',e);showBoot('CLOUD PRISIJUNGIMO KLAIDA');
    const card=document.querySelector('#mogaCloudBoot .moga-cloud-boot-card');if(card){card.querySelector('small').textContent=e.message||String(e);const b=document.createElement('button');b.textContent='BANDYTI DAR KARTĄ';b.style.cssText='margin-top:16px;padding:10px 16px;border-radius:999px;border:1px solid #ff8a00;background:#1c1409;color:#fff;font-weight:900;cursor:pointer';b.onclick=()=>location.reload();card.appendChild(b)}
  }
}

async function rawReq(path,opt={}){
  const headers=new Headers(opt.headers||{});if(token)headers.set('Authorization','Bearer '+token);
  const r=await fetch(API+path,{...opt,headers,cache:'no-store'});
  if(!r.ok){let msg=`MOGA Cloud HTTP ${r.status}`;try{const d=await r.json();msg=d?.message||msg}catch(_){}throw new Error(msg)}
  return r;
}

window.MOGA_CLOUD={
  get ready(){return ready},get tenant(){return tenant},get device(){return device},get token(){return token},
  api:req,raw:rawReq,flush,resolveAll,
  async forcePull(){status('sync','ATNAUJINAMA IŠ CLOUD');const b=await req('/v1/bootstrap');const changed=applyCloudState(b.state||{},b.versions||{});if(changed)window.dispatchEvent(new CustomEvent('moga:data-ready',{detail:{source:'cloud-force-pull'}}));status('ok','CLOUD ✓');return changed},
  async logout(){try{await req('/v1/auth/logout',{method:'POST'})}catch(_){}clearSession()},
  version:APP_VERSION
};
window.MOGA_CLOUD_READY=new Promise(resolve=>window.addEventListener('moga:cloud-ready',e=>resolve(e.detail),{once:true}));
start();
})();
